import { MRT_ColumnFiltersState } from 'mantine-react-table';

import { lotsApi } from './apis/lots';
import { LotsSummary } from './types/lots';
import { getLotsStatsFilters } from './lots-filters';

export type { LotsSummary as LotsStats };

export async function fetchLotsStats(
  filters: MRT_ColumnFiltersState,
): Promise<LotsSummary> {
  const statsFilters = getLotsStatsFilters(filters, 'total');
  return lotsApi.getSummary(statsFilters);
}
